import { createFileRoute, redirect } from '@tanstack/react-router';
import { DEFAULT_DASHBOARD_ID } from '@/components/dashboard/registry';

/** `/dashboard` has no view of its own — send it to the first dashboard. */
export const Route = createFileRoute('/_authenticated/dashboard/')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/$dashboardId',
      params: { dashboardId: DEFAULT_DASHBOARD_ID },
      replace: true,
    });
  },
});
